import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface confirmState {
  message: string;
  clickState: string;
}

const initialConfirmState: confirmState = {
  message: '',
  clickState: '',
};

const confirmSlice = createSlice({
  name: 'confirm',
  initialState: initialConfirmState,
  reducers: {
    setConfirmMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    setConfirmClickState: (state, action: PayloadAction<string>) => {
      state.clickState = action.payload;
    },
  },
});

export const { setConfirmMessage, setConfirmClickState } = confirmSlice.actions;

export default confirmSlice.reducer;
